module.exports = __webpack_public_path__ + "static/media/10_NXV-600A.9b5d64c3.png";